<template>
    <svg v-if="isVerified" class="verified-badge" aria-labelledby="badgeTitle">
        <title id="badgeTitle">Well Traveled Insider</title>
        <use xlink:href="#verified-badge"><title id="badgeTitle">Well Traveled Insider</title></use>
    </svg>
</template>
<script>

export default {
    props:['user'],

    data(){
        return {
            isVerified: this.user ? this.user.is_verified : false
        }
    },
}
</script>
